<div class="container" *ngIf="matrimonio" [class.has-save-bar]="editMode && !isCollaborator">
  <!-- HEADER -->
  <div class="collab-banner" *ngIf="isCollaborator">
    <app-icon name="users" [size]="16" />
    <span>
      {{ "riepilogo.collab_banner" | translate }}
      <ng-container *ngIf="ownerInfo?.contract_name || ownerInfo?.name">
        · {{ "riepilogo.organized_by" | translate }}
        <strong>{{
          ownerInfo?.contract_name ||
            ownerInfo?.name + " " + ownerInfo?.lastname
        }}</strong>
      </ng-container>
    </span>
  </div>

  <div class="riepilogo-header">
    <div class="hero-main">
      <div class="hero-text">
        <p class="riepilogo-eyebrow">{{ "riepilogo.wedding_card" | translate }}</p>
        <h1 class="riepilogo-title">{{ brideFullName }}</h1>
        <p class="riepilogo-date">
          {{ weddingDateDisplay }}<ng-container *ngIf="matrimonio?.event?.time"> · {{ matrimonio.event.time }}</ng-container>
        </p>
      </div>
      <span class="hero-countdown" *ngIf="countdown as cd" [ngClass]="cd.tone">
        {{ cd.key | translate: cd.params }}
      </span>
    </div>

    <div class="hero-status" *ngIf="!isCollaborator">
      <span class="status-chip warn" *ngIf="isQuote">
        <app-icon name="note" [size]="14"></app-icon>
        <span class="chip-text">{{ "quote.badge" | translate }}</span>
      </span>
      <span class="status-chip warn" *ngIf="needsDate">
        <app-icon name="calendar-heart" [size]="14"></app-icon>
        <span class="chip-text">{{ "quote.date_to_set" | translate }}</span>
      </span>
      <button type="button" class="status-chip" *ngIf="!isQuote" [ngClass]="contractStatus.tone" (click)="openContractSection()">
        <app-icon name="file" [size]="14"></app-icon>
        <span class="chip-text">{{ contractStatus.key | translate }}</span>
      </button>
      <button type="button" class="status-chip" [ngClass]="paymentStatus.tone" (click)="setTab(3)">
        <app-icon name="card" [size]="14"></app-icon>
        <span class="chip-text">{{ paymentStatus.key | translate: paymentStatus.params }}</span>
      </button>
      <button type="button" class="status-chip" [ngClass]="teamStatus.tone" (click)="setTab(4)">
        <app-icon name="users" [size]="14"></app-icon>
        <span class="chip-text">{{ teamStatus.key | translate: teamStatus.params }}</span>
      </button>
    </div>

    <!-- Cosa manca per il contratto: la scheda resta in lettura, ogni voce apre la modifica nel punto giusto -->
    <p class="missing-line" *ngIf="missingForContract.length">
      {{ "riepilogo.missing.title" | translate }}:
      <ng-container *ngFor="let m of missingForContract; let last = last">
        <button type="button" class="missing-link" (click)="editAt(m.tab, m.sub)">{{ "crea.missing." + m.key | translate }}</button><span *ngIf="!last" class="missing-sep">·</span>
      </ng-container>
    </p>

    <div class="hero-actions">
      <button
        type="button"
        class="hero-action"
        *ngIf="matrimonio?.event?.location && canSee('event_data')"
        (click)="openInMaps(matrimonio.event.location)"
      >
        <app-icon name="navigate"></app-icon>
        <span>{{ "riepilogo.hero.directions" | translate }}</span>
      </button>
      <ng-container *ngIf="canSee('client')">
        <a class="hero-action" *ngIf="clientPhone" [href]="'tel:' + clientPhone">
          <app-icon name="phone"></app-icon>
          <span>{{ "riepilogo.hero.call" | translate }}</span>
        </a>
        <a class="hero-action" *ngIf="whatsappUrl" [href]="whatsappUrl" target="_blank" rel="noopener">
          <app-icon name="chat"></app-icon>
          <span>WhatsApp</span>
        </a>
        <a class="hero-action" *ngIf="clientEmail" [href]="'mailto:' + clientEmail">
          <app-icon name="mail"></app-icon>
          <span>{{ "riepilogo.hero.email" | translate }}</span>
        </a>
      </ng-container>
      <button type="button" class="hero-action" (click)="shareEvent()">
        <app-icon name="share"></app-icon>
        <span>{{ "riepilogo.hero.share" | translate }}</span>
      </button>
      <div class="hero-more" *ngIf="!isCollaborator">
        <button
          type="button"
          class="hero-action"
          (click)="moreMenuOpen = !moreMenuOpen"
          [attr.aria-expanded]="moreMenuOpen"
        >
          <app-icon name="more"></app-icon>
          <span>{{ "riepilogo.hero.more" | translate }}</span>
        </button>
        <div class="hero-more-backdrop" *ngIf="moreMenuOpen" (click)="moreMenuOpen = false"></div>
        <div class="hero-more-menu" *ngIf="moreMenuOpen">
          <button type="button" class="hero-more-item" *ngIf="!isQuote && !matrimonio?.event?.contract?.file" (click)="setStatus('quote')">
            <app-icon name="note" [size]="16"></app-icon>
            {{ "quote.back_to_quote" | translate }}
          </button>
          <button type="button" class="hero-more-item danger" (click)="moreMenuOpen = false; deleteEvent()">
            <app-icon name="trash" [size]="16"></app-icon>
            {{ "riepilogo.delete_event" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- PREVENTIVO: passo successivo -->
  <div class="quote-next" *ngIf="isQuote && !isCollaborator">
    <p class="quote-next-text" [ngSwitch]="quoteStage">
      <ng-container *ngSwitchCase="'draft'">{{ "quote.banner.draft" | translate }}</ng-container>
      <ng-container *ngSwitchCase="'sent'">{{ "quote.banner.sent" | translate: { date: quoteExpiry } }}</ng-container>
      <ng-container *ngSwitchCase="'expired'">{{ "quote.banner.expired" | translate }}</ng-container>
    </p>
    <button type="button" class="qv-summary" *ngIf="quoteVariants.length" (click)="setTab(1)">
      {{ "quote.variants.summary" | translate: { count: quoteVariants.length, range: quoteVariantRange } }}
    </button>
    <div class="quote-next-actions">
      <button type="button" class="btn-gold quote-primary" *ngIf="quoteStage !== 'sent'" (click)="sendQuote()">
        <app-icon name="send" [size]="16"></app-icon>
        {{ (quoteStage === 'expired' ? "quote.resend" : "quote.send") | translate }}
      </button>
      <button type="button" class="btn-gold quote-primary" *ngIf="quoteStage === 'sent'" (click)="shareQuote()">
        <app-icon name="share" [size]="16"></app-icon>
        {{ "quote.share_again" | translate }}
      </button>
      <button type="button" class="quote-text-btn" (click)="openQuoteMail()">
        {{ "quote.mail.open" | translate }}
      </button>
      <button type="button" class="quote-text-btn" (click)="setStatus('confirmed')">
        {{ "quote.confirm" | translate }}
      </button>
    </div>
  </div>

  <!-- PREVENTIVO: mail da copiare -->
  <div class="mail-backdrop" *ngIf="mailOpen" (click)="closeQuoteMail()">
    <div class="mail-modal" (click)="$event.stopPropagation()">
      <div class="mail-head">
        <h3>{{ "quote.mail.title" | translate }}</h3>
        <button type="button" class="mail-close" (click)="closeQuoteMail()" aria-label="close"><app-icon name="x" [size]="16"></app-icon></button>
      </div>
      <label class="mail-toggle">
        <span class="mail-toggle-text">
          <strong>{{ "quote.mail.include_link" | translate }}</strong>
          <small>{{ "quote.mail.include_link_sub" | translate }}</small>
        </span>
        <span class="toggle-switch">
          <input type="checkbox" [ngModel]="mailIncludeLink" (ngModelChange)="setMailIncludeLink($event)" />
          <span class="toggle-slider"></span>
        </span>
      </label>
      <div class="mail-validity" *ngIf="mailIncludeLink">
        <span class="mail-toggle-text">
          <strong>{{ "quote.mail.validity" | translate }}</strong>
          <small>{{ "quote.mail.validity_hint" | translate }}</small>
        </span>
        <div class="mail-validity-fields">
          <div class="mail-lang-options">
            <button type="button" class="mail-lang-btn" [class.active]="mailValidityMode === 'days'" (click)="setMailValidityMode('days')">
              {{ "quote.mail.validity_days" | translate }}
            </button>
            <button type="button" class="mail-lang-btn" [class.active]="mailValidityMode === 'date'" (click)="setMailValidityMode('date')">
              {{ "quote.mail.validity_until" | translate }}
            </button>
          </div>
          <input
            *ngIf="mailValidityMode === 'days'"
            type="number"
            min="1"
            max="90"
            step="1"
            inputmode="numeric"
            [ngModel]="mailDays"
            [attr.aria-label]="'quote.mail.validity_days' | translate"
            (change)="setMailDays($any($event.target).value, $any($event.target))"
          />
          <input
            *ngIf="mailValidityMode === 'date'"
            type="date"
            class="mail-validity-date"
            [min]="mailUntilMin"
            [max]="mailUntilMax"
            [ngModel]="mailUntil"
            [attr.aria-label]="'quote.mail.validity_until' | translate"
            (change)="setMailUntil($any($event.target).value, $any($event.target))"
          />
        </div>
      </div>
      <div class="mail-lang">
        <span>{{ "quote.mail.language" | translate }}</span>
        <div class="mail-lang-options">
          <button
            type="button"
            *ngFor="let l of mailLangs"
            class="mail-lang-btn"
            [class.active]="mailLang === l"
            (click)="setMailLang(l)"
          >
            {{ l | uppercase }}
          </button>
        </div>
      </div>
      <div class="mail-preview" [innerHTML]="mailHtml"></div>
      <div class="mail-actions">
        <button type="button" class="btn-gold" (click)="copyQuoteMail()">
          <app-icon name="copy" [size]="16"></app-icon>
          {{ "quote.mail.copy" | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="tabs">
    <ng-container *ngFor="let tab of tabs; let i = index">
      <button
        *ngIf="canSeeTab($any(i))"
        [id]="tourTabIds[i]"
        (click)="setTab(i)"
        [class.active]="activeTab === i"
        [attr.aria-label]="tab | translate"
      >
        <app-icon class="tab-icon" [name]="tabIcons[i]" [size]="22"></app-icon>
        <span class="tab-label">{{ tab | translate }}</span>
      </button>
    </ng-container>
  </div>

  <div class="card">
    <div class="card-edit-bar" *ngIf="!isCollaborator && !editMode">
      <button class="header-edit-btn" (click)="startEdit()">
        <app-icon name="edit" [size]="15"></app-icon>
        {{ "riepilogo.edit_btn" | translate }}
      </button>
    </div>

    <!-- ===== TAB 0 — EVENTO (Evento + Cliente + Prova/Sopralluogo + Foto + Partecipanti) ===== -->
    <div *ngIf="activeTab === 0">
      <div class="note-highlight" *ngIf="!editMode && canSee('event_data') && matrimonio?.event?.note?.text">
        <span class="note-highlight-label">
          <app-icon name="note" [size]="14"></app-icon>
          {{ "riepilogo.notes_section" | translate }}
          <ng-container *ngIf="matrimonio.event.note.show_client"> · {{ "quote.notes_visible" | translate }}</ng-container>
        </span>
        <p>{{ matrimonio.event.note.text }}</p>
      </div>

      <div class="timeline" *ngIf="showTimeline">
        <div class="timeline-step" [class.next]="nextStep === 'trial'" [class.done]="trialPast">
          <span class="timeline-dot"></span>
          <div class="timeline-body">
            <span class="timeline-title">{{ (isBeautyCategory ? 'riepilogo.tabs.test' : 'riepilogo.tabs.sopralluogo') | translate }}</span>
            <span class="timeline-when">
              {{ weddingDateTestDisplay }}<ng-container *ngIf="matrimonio.event.test_time"> · {{ matrimonio.event.test_time }}</ng-container>
            </span>
            <span class="timeline-where" *ngIf="matrimonio.event.test_location">{{ matrimonio.event.test_location }}</span>
          </div>
        </div>
        <div class="timeline-step" [class.next]="nextStep === 'event'" [class.done]="eventPast">
          <span class="timeline-dot"></span>
          <div class="timeline-body">
            <span class="timeline-title">{{ "riepilogo.tabs.wedding" | translate }}</span>
            <span class="timeline-when">
              {{ weddingDateDisplay }}<ng-container *ngIf="matrimonio.event.time"> · {{ matrimonio.event.time }}</ng-container>
            </span>
            <span class="timeline-where" *ngIf="matrimonio.event.location">{{ matrimonio.event.location }}</span>
          </div>
        </div>
      </div>

      <ng-container *ngIf="canSee('event_data')">
      <button type="button" class="subsection-head" (click)="toggleSub('evento')">
        <span>{{ "riepilogo.tabs.wedding" | translate }}</span>
        <span class="subsection-meta">
          <span class="contract-badge">{{ "riepilogo.in_contract" | translate }}</span>
          <span class="subsection-chevron" [class.open]="activeSub === 'evento'"><app-icon name="chevron-down" [size]="18"></app-icon></span>
        </span>
      </button>
      <p class="tab-desc">{{ "riepilogo.wedding_tab_desc" | translate }}</p>
      <div class="subsection-body" [class.sub-open]="activeSub === 'evento'">

      <div class="info-box">
        <div class="info">
          <label><span class="field-icon"><app-icon name="calendar" [size]="15"></app-icon></span>{{ "riepilogo.wedding.date" | translate }}</label>
          <ng-container *ngIf="!editMode; else editWeddingDate">
            <p>{{ weddingDateDisplay }}</p>
          </ng-container>
          <ng-template #editWeddingDate>
            <input type="date" [(ngModel)]="weddingDateInput" />
            <div class="period-edit" *ngIf="showPeriodEdit">
              <span class="period-label">{{ "crea.period.label" | translate }}</span>
              <select [(ngModel)]="hintYear" [attr.aria-label]="'crea.period.year' | translate">
                <option [ngValue]="null">{{ "crea.period.year" | translate }}</option>
                <option *ngFor="let y of periodYears" [ngValue]="y">{{ y }}</option>
              </select>
              <select [(ngModel)]="hintPeriod">
                <option value="">{{ "crea.period.any" | translate }}</option>
                <option *ngFor="let p of periodOptions" [value]="p">{{ "crea.period." + p | translate }}</option>
              </select>
            </div>
          </ng-template>
        </div>
        <div class="info">
          <label><span class="field-icon"><app-icon name="clock" [size]="15"></app-icon></span>{{ "riepilogo.wedding.time" | translate }}</label>
          <ng-container *ngIf="!editMode; else editTime">
            <p *ngIf="matrimonio?.event?.time; else addTime">{{ matrimonio?.event?.time }}</p>
            <ng-template #addTime>
              <button type="button" class="add-field-btn" *ngIf="!isCollaborator" (click)="editAt(0, 'evento')">
                + {{ "riepilogo.missing.add_time" | translate }}
              </button>
            </ng-template>
          </ng-container>
          <ng-template #editTime>
            <app-time-picker [(ngModel)]="matrimonio.event.time"></app-time-picker>
          </ng-template>
        </div>
      </div>

      <div class="info-box single">
        <div class="info">
          <label><span class="field-icon"><app-icon name="pin" [size]="15"></app-icon></span>{{ "riepilogo.wedding.location" | translate }}</label>
          <ng-container *ngIf="!editMode; else editLocation">
            <p *ngIf="matrimonio?.event?.location; else addLocation">{{ matrimonio?.event?.location }}</p>
            <ng-template #addLocation>
              <button type="button" class="add-field-btn" *ngIf="!isCollaborator" (click)="editAt(0, 'evento')">
                + {{ "riepilogo.missing.add_location" | translate }}
              </button>
            </ng-template>
            <button type="button" class="maps-link" *ngIf="matrimonio?.event?.location"
              (click)="openInMaps(matrimonio?.event?.location)">
              <app-icon name="navigate" [size]="14"></app-icon> {{ "riepilogo.open_maps" | translate }}
            </button>
          </ng-container>
          <ng-template #editLocation>
            <input type="text" appPlacesAutocomplete (placeSelected)="onLocationPlace($event)" [(ngModel)]="matrimonio.event.location" />
          </ng-template>
          <div class="map-embed" *ngIf="mapsEnabled && !isMobile && !editMode && matrimonio?.event?.location">
            <iframe [src]="mapUrl(matrimonio?.event?.location)" loading="lazy"
              referrerpolicy="no-referrer-when-downgrade" allowfullscreen></iframe>
          </div>
        </div>
      </div>

        <ng-container *ngIf="editMode">
          <div class="info-box single">
            <div class="info">
              <label>{{ "riepilogo.notes_section" | translate }}</label>
              <textarea [(ngModel)]="matrimonio.event.note.text"></textarea>
            </div>
          </div>
          <div class="note-toggles">
          <label class="mail-toggle">
            <span class="mail-toggle-text">
              <strong>{{ "quote.notes_toggle" | translate }}</strong>
              <small>{{ "quote.notes_toggle_sub" | translate }}</small>
            </span>
            <span class="toggle-switch">
              <input type="checkbox" [(ngModel)]="matrimonio.event.note.show_client" />
              <span class="toggle-slider"></span>
            </span>
          </label>
          <label class="mail-toggle" *ngIf="isQuote">
            <span class="mail-toggle-text">
              <strong>{{ "quote.disclaimer_toggle" | translate }}</strong>
              <small>{{ "quote.disclaimer_toggle_sub" | translate }}</small>
            </span>
            <span class="toggle-switch">
              <input type="checkbox" [ngModel]="priceDisclaimer" (ngModelChange)="matrimonio.event.quote_disclaimer = $event" />
              <span class="toggle-slider"></span>
            </span>
          </label>
          </div>
        </ng-container>
      </div>
      </ng-container>

      <ng-container *ngIf="canSee('client')">
      <button type="button" class="subsection-head" (click)="toggleSub('cliente')">
        <span>{{ "riepilogo.tabs.client" | translate }}</span>
        <span class="subsection-meta">
          <span class="contract-badge">{{ "riepilogo.in_contract" | translate }}</span>
          <span class="subsection-chevron" [class.open]="activeSub === 'cliente'"><app-icon name="chevron-down" [size]="18"></app-icon></span>
        </span>
      </button>
      <p class="tab-desc">{{ "riepilogo.client_tab_desc" | translate }}</p>
      <div class="subsection-body" [class.sub-open]="activeSub === 'cliente'">

      <div class="info-box">
        <div class="info">
          <label><span class="field-icon"><app-icon name="user" [size]="15"></app-icon></span>{{ "crea.bride.name" | translate }}</label>
          <ng-container *ngIf="!editMode; else editName">
            <p>{{ matrimonio?.client?.name }}</p>
          </ng-container>
          <ng-template #editName>
            <input type="text" [(ngModel)]="matrimonio.client.name" />
          </ng-template>
        </div>
        <div class="info">
          <label><span class="field-icon"><app-icon name="user" [size]="15"></app-icon></span>{{ "crea.bride.lastname" | translate }}</label>
          <ng-container *ngIf="!editMode; else editLastname">
            <p>{{ matrimonio?.client?.lastname }}</p>
          </ng-container>
          <ng-template #editLastname>
            <input type="text" [(ngModel)]="matrimonio.client.lastname" />
          </ng-template>
        </div>
      </div>

      <div class="info-box">
        <div class="info">
          <label><span class="field-icon"><app-icon name="phone" [size]="15"></app-icon></span>{{ "crea.bride.phone" | translate }}</label>
          <ng-container *ngIf="!editMode; else editPhone">
            <p>
              <a class="client-contact-link" *ngIf="clientPhone" [href]="'tel:' + clientPhone">{{ clientPhone }}</a>
              <button type="button" class="add-field-btn" *ngIf="!clientPhone && !isCollaborator" (click)="editAt(0, 'cliente')">
                + {{ "riepilogo.missing.add_phone" | translate }}
              </button>
              <ng-container *ngIf="!clientPhone && isCollaborator">—</ng-container>
            </p>
          </ng-container>
          <ng-template #editPhone>
            <app-phone-input [(ngModel)]="matrimonio.client.phone" [placeholder]="'crea.bride.phone_placeholder' | translate"></app-phone-input>
          </ng-template>
        </div>
        <div class="info">
          <label><span class="field-icon"><app-icon name="mail" [size]="15"></app-icon></span>{{ "crea.bride.email" | translate }}</label>
          <ng-container *ngIf="!editMode; else editEmail">
            <p>
              <a class="client-contact-link" *ngIf="clientEmail" [href]="'mailto:' + clientEmail">{{ clientEmail }}</a>
              <button type="button" class="add-field-btn" *ngIf="!clientEmail && !isCollaborator" (click)="editAt(0, 'cliente')">
                + {{ "riepilogo.missing.add_email" | translate }}
              </button>
              <ng-container *ngIf="!clientEmail && isCollaborator">—</ng-container>
            </p>
          </ng-container>
          <ng-template #editEmail>
            <input type="email" autocapitalize="off" autocomplete="email" [(ngModel)]="matrimonio.client.email" [placeholder]="'crea.bride.email_placeholder' | translate" />
          </ng-template>
        </div>
      </div>

      <div class="info-box">
        <div class="info">
          <label><span class="field-icon"><app-icon name="home" [size]="15"></app-icon></span>{{ "crea.bride.address" | translate }}</label>
          <ng-container *ngIf="!editMode; else editAddress">
            <p>{{ matrimonio?.client?.address }}</p>
          </ng-container>
          <ng-template #editAddress>
            <input type="text" [(ngModel)]="matrimonio.client.address" />
          </ng-template>
        </div>
        <div class="info">
          <label><span class="field-icon"><app-icon name="cake" [size]="15"></app-icon></span>{{ "crea.bride.dob" | translate }}</label>
          <ng-container *ngIf="!editMode; else editDob">
            <p>{{ matrimonio?.client?.dateOfBirth | date: "dd/MM/yyyy" }}</p>
          </ng-container>
          <ng-template #editDob>
            <input type="date" [(ngModel)]="matrimonio.client.dateOfBirth" />
          </ng-template>
        </div>
      </div>

      <div class="info-box single">
        <div class="info">
          <label><span class="field-icon"><app-icon name="pin" [size]="15"></app-icon></span>{{ "crea.bride.pob" | translate }}</label>
          <ng-container *ngIf="!editMode; else editPob">
            <p>{{ matrimonio?.client?.placeOfBirth }}</p>
          </ng-container>
          <ng-template #editPob>
            <input type="text" [(ngModel)]="matrimonio.client.placeOfBirth" />
          </ng-template>
        </div>
      </div>
      </div>
      </ng-container>


      <ng-container *ngIf="canSee('trial')">
      <button type="button" class="subsection-head" (click)="toggleSub('prova')">
        <span>{{ (isBeautyCategory ? 'riepilogo.tabs.test' : 'riepilogo.tabs.sopralluogo') | translate }}</span>
        <span class="subsection-meta">
          <span class="subsection-chevron" [class.open]="activeSub === 'prova'"><app-icon name="chevron-down" [size]="18"></app-icon></span>
        </span>
      </button>
      <p class="tab-desc">{{ (isBeautyCategory ? 'riepilogo.test_tab_desc' : 'riepilogo.sopralluogo_tab_desc') | translate }}</p>
      <div class="subsection-body" [class.sub-open]="activeSub === 'prova'">

      <div class="info-box">
        <div class="info">
          <label><span class="field-icon"><app-icon name="calendar" [size]="15"></app-icon></span>{{ (isBeautyCategory ? 'riepilogo.trial_date' : 'riepilogo.sopralluogo_date') | translate }}</label>
          <ng-container *ngIf="!editMode; else editTestDate">
            <p>{{ weddingDateTestDisplay }}</p>
          </ng-container>
          <ng-template #editTestDate>
            <input type="date" [(ngModel)]="weddingDateTestInput" />
          </ng-template>
        </div>
        <div class="info">
          <label><span class="field-icon"><app-icon name="clock" [size]="15"></app-icon></span>{{ (isBeautyCategory ? 'riepilogo.trial_time' : 'riepilogo.sopralluogo_time') | translate }}</label>
          <ng-container *ngIf="!editMode; else editTestTime">
            <p>{{ matrimonio?.event?.test_time }}</p>
          </ng-container>
          <ng-template #editTestTime>
            <app-time-picker [(ngModel)]="matrimonio.event.test_time"></app-time-picker>
          </ng-template>
        </div>
        <div class="info">
          <label><span class="field-icon"><app-icon name="euro" [size]="15"></app-icon></span>{{ "riepilogo.trial_cost" | translate }}<span class="contract-badge">{{ "riepilogo.in_contract" | translate }}</span></label>
          <ng-container *ngIf="!editMode; else editTestCost">
            <p>{{ testCost ? ("€ " + (testCost | number: "1.2-2")) : "—" }}</p>
          </ng-container>
          <ng-template #editTestCost>
            <div class="pkg-price-wrap">
              <span class="euro-symbol">€</span>
              <input
                type="number"
                class="pkg-price-input"
                [(ngModel)]="matrimonio.event.test_cost"
                min="0"
                step="0.01"
                inputmode="decimal"
                placeholder="0"
              />
            </div>
          </ng-template>
        </div>
      </div>

      <div class="info-box single">
        <div class="info">
          <label><span class="field-icon"><app-icon name="pin" [size]="15"></app-icon></span>{{ (isBeautyCategory ? 'riepilogo.trial_location' : 'riepilogo.sopralluogo_location') | translate }}</label>
          <ng-container *ngIf="!editMode; else editTestLocation">
            <p>{{ matrimonio?.event?.test_location }}</p>
            <button type="button" class="maps-link" *ngIf="matrimonio?.event?.test_location"
              (click)="openInMaps(matrimonio?.event?.test_location)">
              <app-icon name="navigate" [size]="14"></app-icon> {{ "riepilogo.open_maps" | translate }}
            </button>
          </ng-container>
          <ng-template #editTestLocation>
            <input type="text" appPlacesAutocomplete (placeSelected)="onTestLocationPlace($event)" [(ngModel)]="matrimonio.event.test_location" />
          </ng-template>
          <div class="map-embed" *ngIf="mapsEnabled && !isMobile && !editMode && matrimonio?.event?.test_location">
            <iframe [src]="mapUrl(matrimonio?.event?.test_location)" loading="lazy"
              referrerpolicy="no-referrer-when-downgrade" allowfullscreen></iframe>
          </div>
        </div>
      </div>

      <div class="info-box single">
        <div class="info">
          <label>{{ "riepilogo.notes_section" | translate }}</label>
          <ng-container *ngIf="!editMode; else editTestNote">
            <p class="note-text">
              {{ matrimonio?.event?.test_note?.text || "—" }}
            </p>
          </ng-container>
          <ng-template #editTestNote>
            <textarea
              [(ngModel)]="matrimonio.event.test_note.text"
            ></textarea>
          </ng-template>
        </div>
      </div>
      </div>
      </ng-container>

      <!-- FOTO -->
      <ng-container *ngIf="canSee('photos')">
      <button type="button" class="subsection-head" (click)="toggleSub('foto')">
        <span>{{ "riepilogo.photos_section" | translate }}</span>
        <span class="subsection-meta">
          <span class="subsection-count" *ngIf="matrimonio?.image?.gallery?.length">{{ matrimonio.image.gallery.length }}</span>
          <span class="subsection-chevron" [class.open]="activeSub === 'foto'"><app-icon name="chevron-down" [size]="18"></app-icon></span>
        </span>
      </button>
      <div class="subsection-body" [class.sub-open]="activeSub === 'foto'">
        <div class="info-box single">
          <div class="info">
            <div class="images photo-grid">
              <label class="photo-add" [class.busy]="isUploadingImages">
                <input type="file" accept="image/*" multiple hidden (change)="onPhotoInput($event)" [disabled]="isUploadingImages" />
                <app-icon name="camera" [size]="22"></app-icon>
                <span>{{ (isUploadingImages ? "riepilogo.uploading" : "riepilogo.add_photo") | translate }}</span>
              </label>
              <div
                class="image-thumb"
                *ngFor="let img of matrimonio?.image?.gallery ?? []; let i = index"
              >
                <img
                  [src]="getImageUrl(img.key)"
                  class="image-item"
                  (click)="openLightbox(i)"
                />
                <button
                  *ngIf="editMode"
                  type="button"
                  class="image-delete"
                  (click)="deleteImage(img)"
                  [attr.aria-label]="'riepilogo.delete_photo' | translate"
                >
                  <app-icon name="x" [size]="14"></app-icon>
                </button>
                <span class="image-caption" *ngIf="img.name">{{ img.name }}</span>
              </div>
            </div>
            <p
              class="empty-images"
              *ngIf="!matrimonio?.image?.gallery?.length"
            >
              {{ "riepilogo.no_photos" | translate }}
            </p>
            <div class="upload-area upload-area--desktop">
              <ngx-dropzone
                (change)="onSelect($event)"
                accept="image/*"
                class="dropzone"
              >
                <ngx-dropzone-label>
                  <span class="dropzone-icon"><app-icon name="paperclip" [size]="22" /></span>
                  <span>{{ "riepilogo.drop_photos" | translate }}</span>
                </ngx-dropzone-label>
                <ngx-dropzone-image-preview
                  *ngFor="let f of selectedFiles"
                  [file]="f"
                  (removed)="onRemove(f)"
                  ngProjectAs="ngx-dropzone-preview"
                >
                </ngx-dropzone-image-preview>
              </ngx-dropzone>
              <button
                *ngIf="selectedFiles.length > 0 && !isMobile"
                (click)="uploadImages()"
                [disabled]="isUploadingImages"
                class="upload-confirm-btn"
              >
                {{
                  isUploadingImages
                    ? ("riepilogo.uploading" | translate)
                    : ("riepilogo.upload_action" | translate) + " " + selectedFiles.length + " " + ("riepilogo.photos_unit" | translate)
                }}
              </button>
            </div>
          </div>
        </div>
      </div>
      </ng-container>

      <!-- PARTECIPANTI -->
      <ng-container *ngIf="canSee('participants')">
      <button type="button" class="subsection-head" (click)="toggleSub('partecipanti')">
        <span>{{ "riepilogo.participants_section" | translate }}</span>
        <span class="subsection-meta">
          <span class="subsection-count" *ngIf="matrimonio.schedule.partecipanti?.length">{{ matrimonio.schedule.partecipanti.length }}</span>
          <span class="subsection-chevron" [class.open]="activeSub === 'partecipanti'"><app-icon name="chevron-down" [size]="18"></app-icon></span>
        </span>
      </button>
      <div class="subsection-body" [class.sub-open]="activeSub === 'partecipanti'">
      <div
        class="partecipanti-list"
        *ngIf="matrimonio.schedule.partecipanti?.length > 0"
      >
        <div
          *ngFor="let p of matrimonio.schedule.partecipanti; let i = index"
          class="partecipante-row"
        >
          <div class="partecipante-info">
            <span class="partecipante-name">{{ p.name || "—" }}</span>
            <span class="partecipante-role">{{ p.role }}</span>
          </div>
          <div class="partecipante-services">
            <span class="service-dot" [class.active]="p.hair" [title]="'profile.capelli' | translate"
              ><app-icon name="scissors" [size]="12" /></span
            >
            <span class="service-dot" [class.active]="p.makeup" [title]="'profile.trucco' | translate"
              ><app-icon name="sparkle" [size]="12" /></span
            >
          </div>
          <span class="partecipante-notes" *ngIf="p.notes">{{ p.notes }}</span>
          <button
            *ngIf="editMode"
            class="btn-remove"
            (click)="removePartecipante(i)"
          >
            <app-icon name="x" [size]="14"></app-icon>
          </button>
        </div>
      </div>

      <p
        class="empty-images"
        *ngIf="!matrimonio.schedule.partecipanti?.length && !editMode"
      >
        {{ "riepilogo.no_participants" | translate }}
      </p>

      <div *ngIf="editMode" class="partecipante-quick-add">
        <input
          type="text"
          [(ngModel)]="newPartecipante.name"
          [placeholder]="'riepilogo.name_optional' | translate"
          class="quick-name"
          (keyup.enter)="addPartecipante()"
        />
        <select [(ngModel)]="newPartecipante.role" class="quick-role">
          <option *ngFor="let r of ruoliPartecipanti" [value]="r">
            {{ r }}
          </option>
        </select>
        <label class="quick-toggle" [class.active]="newPartecipante.hair">
          <input type="checkbox" [(ngModel)]="newPartecipante.hair" />
          <app-icon name="scissors" [size]="14" /> {{ "profile.capelli" | translate }}
        </label>
        <label class="quick-toggle" [class.active]="newPartecipante.makeup">
          <input type="checkbox" [(ngModel)]="newPartecipante.makeup" />
          <app-icon name="sparkle" [size]="14" /> {{ "profile.trucco" | translate }}
        </label>
        <input
          type="text"
          [(ngModel)]="newPartecipante.notes"
          [placeholder]="'riepilogo.notes_placeholder' | translate"
          class="quick-notes"
          (keyup.enter)="addPartecipante()"
        />
        <button class="btn-gold quick-add-btn" (click)="addPartecipante()">
          {{ "riepilogo.add_participant" | translate }}
        </button>
      </div>
      </div>
      </ng-container>
    </div>

    <!-- ===== TAB 2 — CONTRATTO (Contratto + Documenti) ===== -->
    <div *ngIf="$any(activeTab) === 2">
      <ng-container *ngIf="!isCollaborator">
        <button type="button" class="subsection-head" (click)="toggleSub('contratto')">
          <span>{{ "riepilogo.tabs.contract" | translate }}</span>
          <span class="subsection-meta">
            <span class="subsection-chevron" [class.open]="activeSub === 'contratto'"><app-icon name="chevron-down" [size]="18"></app-icon></span>
          </span>
        </button>
        <div class="subsection-body" [class.sub-open]="activeSub === 'contratto'">
          <app-contratto-tab></app-contratto-tab>
        </div>
      </ng-container>
      <ng-container *ngIf="canSee('documents')">
        <button type="button" class="subsection-head" (click)="toggleSub('documenti')">
          <span>{{ "riepilogo.tabs.documents" | translate }}</span>
          <span class="subsection-meta">
            <span class="subsection-count" *ngIf="matrimonio?.document?.gallery?.length">{{ matrimonio.document.gallery.length }}</span>
            <span class="subsection-chevron" [class.open]="activeSub === 'documenti'"><app-icon name="chevron-down" [size]="18"></app-icon></span>
          </span>
        </button>
        <div class="subsection-body" [class.sub-open]="activeSub === 'documenti'">
          <app-documenti-tab></app-documenti-tab>
        </div>
      </ng-container>
    </div>

    <!-- ===== TAB 4 — COLLABORATORI ===== -->
    <div *ngIf="$any(activeTab) === 4 && !isCollaborator">
      <h2 class="title">{{ "riepilogo.team_tab" | translate }}</h2>
      <p class="tab-desc">{{ "riepilogo.team_tab_desc" | translate }}</p>

      <div class="unified-team-list" *ngIf="unifiedTeam.length > 0">
        <div *ngFor="let member of unifiedTeam" class="unified-team-row">
          <div
            class="team-avatar-sm"
            [style.background]="getAvatarColor(member.name)"
          >
            {{ getInitials(member.name, member.lastname ?? "") }}
          </div>

          <div class="collaborator-info">
            <span class="collaborator-name"
              >{{ member.name }} {{ member.lastname ?? "" }}</span
            >
            <span class="collaborator-email" *ngIf="member.email">{{
              member.email
            }}</span>
            <span class="collaborator-role" *ngIf="member._type === 'assigned'">
              {{ getRoleLabel(member.role) }}
            </span>
          </div>

          <span
            class="collab-status assigned"
            *ngIf="member._type === 'assigned'"
          >
            {{ "riepilogo.team_status_assigned" | translate }}
          </span>
          <span
            class="collab-status pending"
            *ngIf="member._type === 'collaborator' && member.status === 'pending'"
          >
            <app-icon name="hourglass" [size]="12" /> {{ "riepilogo.team_status_pending" | translate }}
          </span>
          <span
            class="collab-status accepted"
            *ngIf="member._type === 'collaborator' && member.status === 'accepted'"
          >
            {{ "riepilogo.team_status_accepted" | translate }}
          </span>
          <span
            class="collab-status rejected"
            *ngIf="member._type === 'collaborator' && member.status === 'rejected'"
          >
            {{ "riepilogo.team_status_rejected" | translate }}
          </span>

          <div class="collab-actions">
            <a
              class="collab-contact"
              *ngIf="member.email"
              [href]="'mailto:' + member.email"
              [attr.aria-label]="'riepilogo.hero.email' | translate"
            >
              <app-icon name="mail" [size]="16"></app-icon>
            </a>
            <button
              class="btn-outline collab-resend"
              *ngIf="
                member._type === 'collaborator' &&
                (member.status === 'pending' || member.status === 'rejected')
              "
              (click)="resendInvite(member.user_id)"
            >
              {{ "riepilogo.team_resend" | translate }}
            </button>
            <button *ngIf="editMode" class="btn-remove" (click)="removeFromTeam(member)">
              <app-icon name="x" [size]="14"></app-icon>
            </button>
          </div>
        </div>
      </div>

      <p class="empty-images" *ngIf="unifiedTeam.length === 0 && !editMode">
        {{ "riepilogo.team_empty" | translate }}
      </p>

      <button type="button" class="team-add-btn" *ngIf="!editMode" (click)="openTeamPicker()">
        <app-icon name="plus" [size]="16"></app-icon>
        {{ "riepilogo.team_add" | translate }}
      </button>

      <!-- Aggiunta bloccata per i non-Pro (grandfathering: esistenti restano) -->
      <div *ngIf="editMode && !canPro" class="event-pro-inline">
        <span class="pro-lock"><app-icon name="lock" [size]="12" /></span>
        {{ "riepilogo.team_pro_lock" | translate }}
        <button class="event-pro-inline-btn" (click)="goToPlans()">{{ "riepilogo.team_pro_cta" | translate }}</button>
      </div>

      <div *ngIf="editMode && canPro" class="team-accordion" style="margin-top: 1rem">
        <button
          class="team-accordion-toggle"
          (click)="showTeamPicker = !showTeamPicker"
        >
          <span>{{ "riepilogo.team_add_from" | translate }}</span>
          <app-icon class="accordion-chevron" [class.open]="showTeamPicker" name="chevron-down" [size]="16"></app-icon>
        </button>

        <div class="team-picker-list" *ngIf="showTeamPicker">
          <ng-container *ngIf="teamGroup.length > 0">
            <div class="team-picker-group-label">{{ "riepilogo.team_group_team" | translate }}</div>
            <ng-container *ngFor="let member of teamGroup">
              <ng-container
                *ngTemplateOutlet="memberRow; context: { $implicit: member }"
              ></ng-container>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="collaboratoriGroup.length > 0">
            <div class="team-picker-group-label">{{ "riepilogo.team_group_collaborators" | translate }}</div>
            <ng-container *ngFor="let member of collaboratoriGroup">
              <ng-container
                *ngTemplateOutlet="memberRow; context: { $implicit: member }"
              ></ng-container>
            </ng-container>
          </ng-container>

          <p
            class="team-picker-empty"
            *ngIf="teamGroup.length === 0 && collaboratoriGroup.length === 0"
          >
            {{ "riepilogo.team_picker_empty" | translate }}
          </p>
        </div>
      </div>

      <ng-template #memberRow let-member>
        <div class="team-pick-compact">
          <div
            class="team-avatar-sm"
            [style.background]="getAvatarColor(member.name)"
          >
            {{ getInitials(member.name, member.lastname) }}
          </div>
          <div class="team-card-info">
            <span class="team-row-name"
              >{{ member.name }} {{ member.lastname }}</span
            >
            <div class="team-chips">
              <span class="team-chip" *ngIf="member.service?.hair"
                >{{ "profile.capelli" | translate }}</span
              >
              <span class="team-chip" *ngIf="member.service?.makeup"
                >{{ "profile.trucco" | translate }}</span
              >
              <span class="team-chip" *ngIf="member.service?.photo"
                >{{ "profile.foto" | translate }}</span
              >
            </div>
          </div>
          <label class="toggle-switch">
            <input
              type="checkbox"
              [checked]="isTeamMemberAssigned(member)"
              (change)="toggleTeamMember(member)"
            />
            <span class="toggle-slider"></span>
          </label>
        </div>
      </ng-template>

      <!-- VISIBILITÀ SEZIONI PER QUESTO EVENTO (a scomparsa) -->
      <button
        type="button"
        class="visibility-toggle-header"
        (click)="eventVisibilityOpen = !eventVisibilityOpen"
      >
        <span>{{ "riepilogo.visibility.title" | translate }}</span>
        <app-icon class="accordion-chevron" [class.open]="eventVisibilityOpen" name="chevron-down" [size]="16"></app-icon>
      </button>

      <ng-container *ngIf="eventVisibilityOpen">
        <p class="visibility-hint">{{ "riepilogo.visibility.hint" | translate }}</p>

        <p class="visibility-group-title">{{ "riepilogo.visibility.collaborators_see" | translate }}</p>
        <div class="visibility-list">
          <label class="visibility-item" *ngFor="let s of visibilitySections">
            <span class="visibility-section-label">{{ s.label | translate }}</span>
            <span class="toggle-switch">
              <input
                type="checkbox"
                [checked]="eventCollaboratorVisibility[s.key]"
                (change)="toggleEventCollaboratorVisibility(s.key)"
              />
              <span class="toggle-slider"></span>
            </span>
          </label>
        </div>

        <p class="visibility-group-title">{{ "riepilogo.visibility.team_see" | translate }}</p>
        <div class="visibility-list">
          <label class="visibility-item" *ngFor="let s of visibilitySections">
            <span class="visibility-section-label">{{ s.label | translate }}</span>
            <span class="toggle-switch">
              <input
                type="checkbox"
                [checked]="eventTeamVisibility[s.key]"
                (change)="toggleEventTeamVisibility(s.key)"
              />
              <span class="toggle-slider"></span>
            </span>
          </label>
        </div>

        <div class="visibility-actions">
          <button class="btn-gold" (click)="saveEventVisibility()">
            {{ "riepilogo.visibility.save" | translate }}
          </button>
          <button class="btn-outline" (click)="resetEventVisibility()">
            {{ "riepilogo.visibility.reset" | translate }}
          </button>
        </div>
      </ng-container>
    </div>

    <!-- ===== TAB 1 — SERVIZI (Servizi + Trasferta + Sconto) ===== -->
    <ng-container *ngIf="$any(activeTab) === 1">
      <ng-container *ngIf="canSee('services')">
      <button type="button" class="subsection-head" (click)="toggleSub('servizi')">
        <span>{{ "riepilogo.tabs.logistics" | translate }}</span>
        <span class="subsection-meta">
          <span class="contract-badge">{{ "riepilogo.in_contract" | translate }}</span>
          <span class="subsection-chevron" [class.open]="activeSub === 'servizi'"><app-icon name="chevron-down" [size]="18"></app-icon></span>
        </span>
      </button>
      <p class="tab-desc">{{ "riepilogo.logistics_tab_desc" | translate }}</p>
      <div class="subsection-body" [class.sub-open]="activeSub === 'servizi'">

      <!-- Proposte alternative del preventivo: la scheda mostra e modifica quella selezionata -->
      <div class="qv-bar" *ngIf="isQuote && !isCollaborator && (quoteVariants.length || editMode)">
        <div class="qv-tabs" role="tablist">
          <button
            type="button"
            role="tab"
            *ngFor="let v of quoteVariants"
            class="qv-tab"
            [class.active]="v.id === activeVariant"
            [attr.aria-selected]="v.id === activeVariant"
            (click)="selectQuoteVariant(v.id)"
          >
            <span class="qv-name">{{ v.name || ("quote.variants.untitled" | translate) }}</span>
            <span class="qv-total">€ {{ quoteVariantTotal(v) | number: "1.2-2" }}</span>
          </button>
          <button type="button" class="qv-tab qv-tab--add" (click)="addQuoteVariant()" [attr.aria-label]="'quote.variants.add' | translate">
            <app-icon name="plus" [size]="14"></app-icon>
            <span *ngIf="!quoteVariants.length">{{ "quote.variants.add_first" | translate }}</span>
          </button>
        </div>
        <div class="qv-edit" *ngIf="editMode && activeQuoteVariant as v">
          <input
            type="text"
            class="qv-input"
            [(ngModel)]="v.name"
            maxlength="40"
            [placeholder]="'quote.variants.name' | translate"
            [attr.aria-label]="'quote.variants.name' | translate"
          />
          <input
            type="text"
            class="qv-input"
            [(ngModel)]="v.note"
            maxlength="200"
            [placeholder]="'quote.variants.note' | translate"
            [attr.aria-label]="'quote.variants.note' | translate"
          />
          <button type="button" class="qv-remove" (click)="removeQuoteVariant(v)" [attr.aria-label]="'quote.variants.remove' | translate">
            <app-icon name="trash" [size]="15"></app-icon>
          </button>
        </div>
        <p class="qv-hint" *ngIf="editMode && quoteVariants.length">{{ "quote.variants.hint" | translate }}</p>
      </div>

      <app-load-error *ngIf="editMode && profileLoadError" [message]="'profile.listino.load_error' | translate" (retry)="loadProfile()"></app-load-error>
      <div *ngIf="editMode && !profileLoadError && profileServices.length === 0" class="empty-images">
        {{ "riepilogo.no_services_profile" | translate }} ·
        <a routerLink="/listino">{{ "riepilogo.add_from_profile" | translate }}</a>
      </div>

      <div>
        <div *ngIf="!editMode">
          <p class="empty-images" *ngIf="selectedServices.length === 0">
            {{ "riepilogo.no_services_selected" | translate }}
          </p>
          <div class="packages-readonly" *ngIf="selectedServices.length > 0 || testCost > 0 || travelFee > 0">
            <div *ngFor="let s of selectedServices" class="pkg-row">
              <span class="pkg-name">
                {{ s.name }}
                <span class="pkg-qty-badge" *ngIf="(s.quantity ?? 1) > 1"
                  >×{{ s.quantity }}</span
                >
                <span class="pkg-qty-badge" *ngIf="s.custom">{{ "riepilogo.custom_service.badge" | translate }}</span>
              </span>
              <span
                class="pkg-price"
                *ngIf="matrimonio?.event?.show_prices"
              >
                € {{ s.price * (s.quantity ?? 1) | number: "1.2-2" }}
              </span>
            </div>
            <div class="pkg-row" *ngIf="testCost > 0">
              <span class="pkg-name">{{ "riepilogo.trial_cost" | translate }}</span>
              <span class="pkg-price" *ngIf="matrimonio?.event?.show_prices">
                € {{ testCost | number: "1.2-2" }}
              </span>
            </div>
            <div class="pkg-row" *ngIf="travelFee > 0">
              <span class="pkg-name">{{ "riepilogo.travel.label" | translate }}</span>
              <span class="pkg-price" *ngIf="matrimonio?.event?.show_prices">
                € {{ travelFee | number: "1.2-2" }}
              </span>
            </div>
            <div class="pkg-row pkg-row--discount" *ngIf="discountEuro > 0 && matrimonio?.event?.show_prices">
              <span class="pkg-name">{{ discountLabel }}</span>
              <span class="pkg-price">− € {{ discountEuro | number: "1.2-2" }}</span>
            </div>
          </div>
        </div>

        <div *ngIf="editMode" class="packages-edit">
          <button type="button" class="btn-outline" (click)="addCustomService()">
            <app-icon name="plus" [size]="14"></app-icon>{{ "riepilogo.custom_service.add" | translate }}
          </button>

          <div *ngFor="let c of customServices" class="pkg-edit-row pkg-custom-row">
            <div class="pkg-custom-head">
              <input type="text" class="pkg-name-input" [(ngModel)]="c.name" [placeholder]="'riepilogo.custom_service.name' | translate" />
              <button type="button" class="qty-btn" (click)="removeCustomService(c)" [attr.aria-label]="'riepilogo.custom_service.remove' | translate">
                <app-icon name="trash" [size]="14"></app-icon>
              </button>
            </div>
            <div class="pkg-custom-head">
              <input type="text" class="pkg-name-input" [(ngModel)]="c.description" [placeholder]="'riepilogo.custom_service.description' | translate" />
            </div>
            <div class="pkg-qty-wrap">
              <button type="button" class="qty-btn" (click)="c.quantity = max1((c.quantity ?? 1) - 1)">−</button>
              <span class="qty-value">{{ c.quantity ?? 1 }}</span>
              <button type="button" class="qty-btn" (click)="c.quantity = max1((c.quantity ?? 1) + 1)">+</button>
            </div>
            <div class="pkg-price-wrap">
              <span class="euro-symbol">€</span>
              <input type="number" class="pkg-price-input" [(ngModel)]="c.price" min="0" step="0.01" />
            </div>
            <span class="pkg-subtotal">= € {{ (+c.price || 0) * (c.quantity ?? 1) | number: "1.2-2" }}</span>
          </div>

          <div *ngFor="let s of profileServices" class="pkg-edit-row">
            <label class="pkg-check">
              <span class="pkg-check-text">
                <span class="pkg-name-input-label">{{ s.name }}</span>
                <span class="pkg-desc" *ngIf="s.description">{{
                  s.description
                }}</span>
              </span>
              <span class="toggle-switch">
                <input
                  type="checkbox"
                  [checked]="isServiceSelected(s)"
                  (change)="toggleService(s)"
                />
                <span class="toggle-slider"></span>
              </span>
            </label>

            <ng-container *ngIf="isServiceSelected(s)">
              <div class="pkg-qty-wrap">
                <button
                  class="qty-btn"
                  (click)="setServiceQuantity(s, getServiceQuantity(s) - 1)"
                >
                  −
                </button>
                <span class="qty-value">{{ getServiceQuantity(s) }}</span>
                <button
                  class="qty-btn"
                  (click)="setServiceQuantity(s, getServiceQuantity(s) + 1)"
                >
                  +
                </button>
              </div>
              <div class="pkg-price-wrap">
                <span class="euro-symbol">€</span>
                <input
                  type="number"
                  class="pkg-price-input"
                  [value]="getServicePrice(s)"
                  (change)="setServicePrice(s, +$any($event.target).value)"
                  min="0"
                  step="0.01"
                />
              </div>
              <span class="pkg-subtotal">
                = €
                {{
                  getServicePrice(s) * getServiceQuantity(s) | number: "1.2-2"
                }}
              </span>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- TRASFERTA -->
      <div class="info-box single travel-box">
        <div class="info">
          <label class="travel-label"><span class="field-icon"><app-icon name="car" [size]="15"></app-icon></span>{{ "riepilogo.travel.label" | translate }}</label>
          <ng-container *ngIf="!editMode">
            <p>{{ travelFee > 0 ? ('€ ' + (travelFee | number: "1.2-2")) : '—' }}</p>
          </ng-container>
          <div *ngIf="editMode" class="travel-grid">
            <div class="travel-col">
              <span class="travel-col-title">{{ "riepilogo.travel.manual_title" | translate }}</span>
              <div class="pkg-price-wrap">
                <span class="euro-symbol">€</span>
                <input
                  type="number"
                  class="pkg-price-input"
                  [(ngModel)]="event.financial.travel_fee.cost"
                  min="0"
                  step="0.01"
                />
                <span class="travel-total-tag">{{ "riepilogo.travel.total" | translate }}</span>
              </div>
            </div>

            <div class="travel-col travel-col--auto">
              <span class="travel-col-title">{{ "riepilogo.travel.auto_title" | translate }}</span>
              <div class="travel-auto-row">
                <div class="pkg-price-wrap">
                  <span class="euro-symbol">€</span>
                  <input
                    type="number"
                    class="pkg-price-input"
                    [(ngModel)]="travelRatePerKm"
                    min="0"
                    step="0.01"
                  />
                  <span class="travel-total-tag">{{ "riepilogo.travel.per_km" | translate }}</span>
                </div>
                <button
                  type="button"
                  class="btn-gold travel-calc-btn"
                  (click)="calculateTravelFee()"
                  [disabled]="calculatingTravel"
                >
                  {{ (calculatingTravel ? 'riepilogo.travel.calculating' : 'riepilogo.travel.calculate') | translate }}
                  <span *ngIf="!canProMaps" class="pro-lock"><app-icon name="lock" [size]="12" /></span>
                </button>
              </div>
              <span class="travel-auto-hint">{{ "riepilogo.travel.auto_hint" | translate }}</span>
              <span class="travel-breakdown" *ngIf="travelBreakdown">{{ travelBreakdown }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- SCONTO -->
      <div class="info-box single travel-box" *ngIf="editMode">
        <div class="info">
          <label class="travel-label"><span class="field-icon"><app-icon name="euro" [size]="15"></app-icon></span>{{ "riepilogo.discount.label" | translate }}</label>
          <div class="discount-row">
            <div class="discount-unit">
              <button type="button" [class.active]="discount.type !== 'percent'" (click)="setDiscountType('fixed')" [attr.aria-label]="'deposit_toggle.fixed' | translate">€</button>
              <button type="button" [class.active]="discount.type === 'percent'" (click)="setDiscountType('percent')" [attr.aria-label]="'deposit_toggle.percent' | translate">%</button>
            </div>
            <div class="pkg-price-wrap">
              <span class="euro-symbol">{{ discount.type === 'percent' ? '%' : '€' }}</span>
              <input
                type="number"
                class="pkg-price-input"
                [(ngModel)]="discount.value"
                min="0"
                [max]="discount.type === 'percent' ? 100 : null"
                step="0.01"
                inputmode="decimal"
              />
            </div>
            <span class="discount-resolved" *ngIf="discountEuro > 0">− € {{ discountEuro | number: "1.2-2" }}</span>
          </div>
          <input
            type="text"
            class="discount-label-input"
            [(ngModel)]="discount.label"
            maxlength="60"
            [placeholder]="'riepilogo.discount.description_placeholder' | translate"
            [attr.aria-label]="'riepilogo.discount.description' | translate"
          />
          <label class="toggle-row" *ngIf="discount.type === 'percent' && travelFee > 0">
            <span>{{ "riepilogo.discount.include_travel" | translate }}</span>
            <span class="toggle-switch">
              <input type="checkbox" [(ngModel)]="discount.include_travel" />
              <span class="toggle-slider"></span>
            </span>
          </label>
        </div>
      </div>

      <!-- Il totale lo mostra già il riquadro Pagamenti: qui serve solo al collaboratore -->
      <div class="totale-riepilogo" *ngIf="!editMode && isCollaborator && (selectedServices.length > 0 || testCost > 0)">
        <div class="totale-row">
          <span class="totale-label">{{ "riepilogo.costs.total" | translate }}</span>
          <span class="totale-value">€ {{ totalAll | number: "1.2-2" }}</span>
        </div>
      </div>

      <div *ngIf="editMode" class="toggle-options">
        <label class="toggle-row">
          <span>{{ "riepilogo.show_prices" | translate }}</span>
          <span class="toggle-switch">
            <input type="checkbox" [(ngModel)]="matrimonio.event.show_prices" />
            <span class="toggle-slider"></span>
          </span>
        </label>
        <label class="toggle-row">
          <span>{{ "riepilogo.show_total" | translate }}</span>
          <span class="toggle-switch">
            <input type="checkbox" [(ngModel)]="matrimonio.event.show_total" />
            <span class="toggle-slider"></span>
          </span>
        </label>
      </div>
      </div>
      </ng-container>
    </ng-container>

    <!-- ===== TAB 3 — PAGAMENTI ===== -->
    <ng-container *ngIf="$any(activeTab) === 3 && !isCollaborator">
      <app-pagamenti-tab></app-pagamenti-tab>
    </ng-container>

  </div>
  <!-- /card -->

  <!-- BARRA SALVA (modifica) -->
  <div class="save-bar" *ngIf="editMode && !isCollaborator">
    <button type="button" class="btn-outline save-bar-cancel" (click)="cancelEdit()">
      {{ "common.cancel" | translate }}
    </button>
    <button type="button" class="btn-gold save-bar-save" (click)="saveEdit()">
      <app-icon name="check" [size]="16"></app-icon>
      {{ "riepilogo.save_btn" | translate }}
    </button>
  </div>

  <!-- LIGHTBOX -->
  <div class="lightbox-overlay" *ngIf="lightboxOpen" (click)="closeLightbox()">
    <div class="lightbox-container" (click)="$event.stopPropagation()">
      <button class="lightbox-close" (click)="closeLightbox()" aria-label="close"><app-icon name="x" [size]="18"></app-icon></button>
      <swiper-container
        #lightboxSwiper
        class="lightbox-swiper"
        [attr.initial-slide]="lightboxIndex"
        navigation="true"
        pagination="true"
        zoom="true"
        keyboard="true"
        space-between="0"
        slides-per-view="1"
        (swiperslidechange)="onSlideChange($event)"
      >
        <swiper-slide *ngFor="let image of matrimonio.image.gallery">
          <div class="swiper-zoom-container">
            <img [src]="getImageUrl(image.key)" class="lightbox-img" />
          </div>
        </swiper-slide>
      </swiper-container>
      <div class="lightbox-counter">
        {{ lightboxIndex + 1 }} / {{ matrimonio.image.gallery.length }}
      </div>
      <div class="lightbox-meta" *ngIf="matrimonio.image.gallery[lightboxIndex] as cur">
        <input
          class="document-name-input"
          [(ngModel)]="cur.name"
          (blur)="saveImageMeta(cur)"
          [placeholder]="'riepilogo.document_name_placeholder' | translate"
        />
        <textarea
          class="document-note-input"
          [(ngModel)]="cur.note"
          (blur)="saveImageMeta(cur)"
          [placeholder]="'riepilogo.document_note_placeholder' | translate"
        ></textarea>
        <button
          type="button"
          class="lightbox-delete-btn"
          (click)="deleteImage(cur)"
          [attr.aria-label]="'common.delete' | translate"
          [title]="'common.delete' | translate"
        >
          <app-icon name="trash" [size]="16" />
        </button>
      </div>
      <div class="lightbox-thumbs">
        <img
          *ngFor="let image of matrimonio.image.gallery; let i = index"
          [src]="getImageUrl(image.key)"
          class="lightbox-thumb"
          [class.active]="i === lightboxIndex"
          (click)="goToSlide(i)"
        />
      </div>
    </div>
  </div>
</div>
